import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { PHONE_DISPLAY, PHONE_TEL } from "../lib/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "About", href: "#about" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const Logo = ({ className = "h-14" }) => (
  <img
    src="/logo.png"
    alt="Leading Edge Concrete"
    data-testid="lec-logo"
    className={`${className} w-auto rounded-md`}
  />
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="navbar"
      className="fixed inset-x-0 top-0 z-50 bg-white/85 shadow-[0_1px_0_rgba(17,17,17,0.08)] backdrop-blur-xl"
    >
      <div className="flex h-[88px] w-full items-center justify-between px-5 md:px-10">
        <a
          href="#top"
          data-testid="nav-home-link"
          onClick={(e) => go(e, "#top")}
          aria-label="Leading Edge Concrete — home"
        >
          <Logo />
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={(e) => go(e, l.href)}
              className="text-sm font-semibold tracking-wide text-lec-ink transition-colors duration-200 hover:text-lec-green"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={PHONE_TEL}
            data-testid="nav-call-button"
            className="hidden items-center gap-2 text-sm font-bold text-lec-ink transition-colors duration-200 hover:text-lec-green md:flex"
          >
            <Phone className="h-4 w-4" strokeWidth={2.5} />
            {PHONE_DISPLAY}
          </a>
          <button
            data-testid="nav-menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="text-lec-ink lg:hidden"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="border-t border-lec-line bg-white px-5 pb-6 pt-2 lg:hidden"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={(e) => go(e, l.href)}
              className="block border-b border-lec-line py-4 font-display text-lg font-semibold text-lec-ink"
            >
              {l.label}
            </a>
          ))}
          <a
            href={PHONE_TEL}
            data-testid="nav-mobile-call-button"
            className="mt-4 flex items-center gap-2 text-sm font-bold text-lec-ink"
          >
            <Phone className="h-4 w-4" strokeWidth={2.5} /> Call Damien — {PHONE_DISPLAY}
          </a>
        </nav>
      )}
    </header>
  );
};
